import api from "@/lib/apis/api";
import ApiStrings from "@/lib/apis/api-strings";

export async function loginUser(payload: LoginPayload): Promise<UserResponse> {
  const response = await api.post<UserResponse>(ApiStrings.LOGIN, payload);
  return response.data;
}

export async function fetchUserProfile(): Promise<UserResponse> {
  const response = await api.get<UserResponse>(ApiStrings.ME);
  return response.data;
}

export async function registerUser(payload: RegisterPayload) {
  const response = await api.post(ApiStrings.REGISTER, payload);
  return response.data;
}

export async function updateCurrentUser(payload: FormData): Promise<UpdateUserResponse> {
  const response = await api.put<Promise<UpdateUserResponse>>(ApiStrings.ME, payload, {
    headers: {
      ...(payload instanceof FormData
        ? { "Content-Type": "multipart/form-data" }
        : {}),
    },
  });
  return response.data;
}

export async function getUserProfileDetails({ page = 1, limit = 10, username = "" }): Promise<PostsResponse> {
  const response = await api.get<PostsResponse>(ApiStrings.USER_DETAILS(username), { params: { page, limit } });
  return response.data;
}

export async function updatePrivacySetting(payload: object) {
  const response = await api.post(ApiStrings.PRIVACY_SETTING, payload);
  return response.data;
}

export async function changePassword(payload: ChangePasswordPayload) {
  const response = await api.post(ApiStrings.CHANGE_PASSWORD, payload);
  return response.data;
}
export async function notificationPreferences(payload: object) {
  const response = await api.post(ApiStrings.NOTIFICATION_PREFERENCE, payload);
  return response.data;
}
export async function enable2FA() {
  const response = await api.post(ApiStrings.ENABLE_2FA);
  return response.data;
}
export async function disable2FA() {
  const response = await api.post(ApiStrings.DISABLE_2FA);
  return response.data;
}
export async function verify2FA(token: string) {
  const response = await api.post(ApiStrings.VERIFY_2FA, { token });
  return response.data;
}
export async function recoverLogin(payload: RecoverLoginPayload) {
  const response = await api.post(ApiStrings.RECOVER_LOGIN, payload);
  return response.data;
}
export async function recoverLoginWithEmail(payload: EmailVerifyPayload) {
  const response = await api.post(ApiStrings.EMAIL_VERIFY_2FA, payload);
  return response.data;
}
export async function requestOtp(email: string) {
  const response = await api.post(ApiStrings.REQUEST_OTP, { email });
  return response.data;
}
export async function explorePeoples({ page = 1, limit = 10, search, location, title, interests }: DiscoverParams): Promise<DiscoverPeopleResponse> {
  const params: Record<string, any> = {
    page,
    limit,
  };

  if (search)
    params.search = search;
  if (location)
    params.location = location;
  if (title)
    params.title = title;
  if (interests && interests.length > 0)
    params.interests = interests;

  const response = await api.get<DiscoverPeopleResponse>(ApiStrings.DISCOVER_PEOPLE, { params });
  return response.data;
}

export async function deleteAccount(): Promise<DeleteUserResponse> {
  const response = await api.delete<DeleteUserResponse>(ApiStrings.DELETE_ACCOUNT);
  return response.data;
}
export async function cancelAccountDeletion(): Promise<UserResponse> {
  const response = await api.post<UserResponse>(ApiStrings.CANCEL_ACCOUNT_DELETE, {});
  return response.data;
}
export async function getSessions(): Promise<SessionsResponse> {
  const response = await api.get<SessionsResponse>(ApiStrings.GET_SESSIONS);
  return response.data;
}
export async function deleteSession(id: number) {
  const response = await api.delete(`${ApiStrings.GET_SESSIONS}${id}`);
  return response.data;
}
export async function deleteAllSession() {
  const response = await api.delete(ApiStrings.GET_SESSIONS);
  return response.data;
}
export async function logoutCurrentUser() {
  const response = await api.get(ApiStrings.LOGOUT);
  return response.data;
}
export async function resendVerificationEmail(email: string) {
  const response = await api.post(ApiStrings.RESEND_EMAIL, { email });
  return response.data;
}
export async function forgotPassword(email: string) {
  const response = await api.post(ApiStrings.FORGOT_PASSWORD, { email });
  return response.data;
}
export async function resetPassword(payload: PasswordResetPayload) {
  const response = await api.post(ApiStrings.RESET_PASSWORD, payload);
  return response.data;
}
export async function verifyStep2(payload: VerificationPayload) {
  const response = await api.post(ApiStrings.VERIFY_STEP2, payload);
  return response.data;
}
export async function verifyStep3(reason: string) {
  const response = await api.post(ApiStrings.VERIFY_STEP3, { reason });
  return response.data;
}
export async function badgeStatus(): Promise<BadgeStatusResponse> {
  const response = await api.get<BadgeStatusResponse>(ApiStrings.STATUS);
  return response.data;
}
export async function blockUser(blockedId: number) {
  const response = await api.post(ApiStrings.BLOCK, { blockedId });
  return response.data;
}
export async function unBlock(blockedId: number) {
  const response = await api.post(ApiStrings.UNBLOCK, { blockedId });
  return response.data;
}
export async function getBlockUsers(): Promise<BlockUsersResponse> {
  const response = await api.get<BlockUsersResponse>(ApiStrings.GET_BLOCK_USERS);
  return response.data;
}
export async function checkMiniumRequirement(): Promise<BadgeStatusBeforeApplyResponse> {
  const response = await api.get<BadgeStatusBeforeApplyResponse>(ApiStrings.CHECK_MIN_REQUIREMENT);
  return response.data;
}
export async function verifyStep1(payload: FormData) {
  const response = await api.post(ApiStrings.VERIFY_STEP1, payload, {
    headers: {
      ...(payload instanceof FormData
        ? { "Content-Type": "multipart/form-data" }
        : {}),
    },
  });
  return response.data;
}
